module.exports = __webpack_public_path__ + "static/21-6723ecceb2b94ed873fe2bd69ffc79b8.jpg";